import React, { useEffect, useState } from "react";
import axios from "axios";
import { host } from "../../api/ApiCalls";
import { useAuthStore } from "../../store/authStore";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import Loading from "../../assets/Loading.json";

const WithdrawPage = () => {
  const { user } = useAuthStore();
  const [info, setInfo] = useState(null);
  const [amount, setAmount] = useState("");
  const [withdrawRequestLoading, setWithdrawRequestLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    accountHolderName: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
  });
    const token = user?.token || JSON.parse(localStorage.getItem("academiaHubToken"));
  
  useEffect(() => {
    //   const token = await JSON.parse(localStorage.getItem("academiaHubToken"));
    axios
      .get(`${host}/api/withdraw`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      .then((res) => {
        setInfo(res.data.data);
        if (res.data.data.bankDetails?.accountNumber) {
          setBankDetails(res.data.data.bankDetails);
        }
      });
  }, []);

  const handleWithdraw = async (e) => {
    e.preventDefault();
    setWithdrawRequestLoading(true);
    if (!amount || isNaN(amount)) {
      setWithdrawRequestLoading(false);
      return toast.error("Enter a valid amount");
    }

    try {
      const res = await axios.post(
        `${host}/api/withdraw/request`,
        { amount, bankDetails },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        toast.success(res.data.message);
        setAmount("");
        setInfo((prev) => ({
  ...prev,
  withdrawBalance: prev.withdrawBalance - amount,
  withdrawRequests: [
    ...(Array.isArray(prev.withdrawRequests) ? prev.withdrawRequests : []),
    { amount, status: "pending", requestedAt: new Date() },
  ],
}));

      }
      setWithdrawRequestLoading(false);
    } catch (err) {
      toast.error(err.response?.data?.message || "Withdraw failed");
      setWithdrawRequestLoading(false);
    }
  };

  if (!info) {
      return (
        <div className="flex items-center justify-center text-gray-800 m-8">
          <div className="w-80">
            <Lottie animationData={Loading} loop={true} />
          </div>
        </div>
      );
    }

  return (
    <div className="max-w-2xl mx-auto py-10">
      <h2 className="text-2xl font-semibold mb-4">Withdraw Funds</h2>
      <p className="mb-4">
        Current Balance:{" "}
        <span className="font-bold text-green-600">${info.withdrawBalance}</span>
      </p>

      <form onSubmit={handleWithdraw} className="space-y-4">
        <input
          type="number"
          min="1"
          max={info.withdrawBalance}
          placeholder="Withdraw Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full border px-4 py-2 rounded"
        />

        {!info.bankDetails?.accountNumber && (
          <>
            <input
              type="text"
              placeholder="Account Holder Name"
              value={bankDetails.accountHolderName}
              onChange={(e) =>
                setBankDetails({ ...bankDetails, accountHolderName: e.target.value })
              }
              className="w-full border px-4 py-2 rounded"
              required
            />
            <input
              type="text"
              placeholder="Bank Name"
              value={bankDetails.bankName}
              onChange={(e) =>
                setBankDetails({ ...bankDetails, bankName: e.target.value })
              }
              className="w-full border px-4 py-2 rounded"
              required
            />
            <input
              type="text"
              placeholder="Account Number"
              value={bankDetails.accountNumber}
              onChange={(e) =>
                setBankDetails({ ...bankDetails, accountNumber: e.target.value })
              }
              className="w-full border px-4 py-2 rounded"
              required
            />
            <input
              type="text"
              placeholder="IFSC Code (optional)"
              value={bankDetails.ifscCode}
              onChange={(e) =>
                setBankDetails({ ...bankDetails, ifscCode: e.target.value })
              }
              className="w-full border px-4 py-2 rounded"
            />
          </>
        )}

        <button
          type="submit"
          className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:opacity-50"
          disabled={withdrawRequestLoading}
        >
          {withdrawRequestLoading ? (
    <div className="flex items-center justify-center gap-2">
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
        ></path>
      </svg>
      Requesting...
    </div>
  ) : (
    "Request Withdraw"
  )}
        </button>
      </form>

      <div className="mt-10">
        <h3 className="text-lg font-semibold mb-2">Withdraw History</h3>
        <ul className="space-y-2">
          {info.withdrawRequests?.map((req, i) => (
            <li
              key={i}
              className="flex justify-between items-center bg-gray-100 px-4 py-2 rounded"
            >
              <span>${req.amount}</span>
              <span
                className={`${
                  req.status === "pending"
                    ? "text-yellow-600"
                    : req.status === "approved"
                    ? "text-green-600"
                    : "text-red-600"
                } capitalize`}
              >
                {req.status}
              </span>
              <span className="text-sm text-gray-500">
                {new Date(req.requestedAt).toLocaleDateString()}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default WithdrawPage;
